import { faBuildings } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import type { GlobalSearchOrgLabelProps } from './GlobalSearchOrgLabel.types'

export const GlobalSearchOrgLabel = ({
  organisationId,
  organisationName,
  inline,
}: GlobalSearchOrgLabelProps) => {
  if (!organisationName && !organisationId) {
    return null
  }

  return (
    <span className="gs-autocomplete-org-label">
      {inline && (
        <span className="gs-autocomplete-org-label__separator">·</span>
      )}
      <FontAwesomeIcon height={10} icon={faBuildings} width={10} />
      {/* Trailing space separates ID from name when both are present */}
      {!!organisationId && `${organisationId} `}
      {organisationName}
    </span>
  )
}
